module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-swap-red-64415b.svg";